import {
    collection,
    component,
    CustomObjectContextData,
    EntityData,
    field,
    identifier,
    LocalisableEntityData,
    reloadable,
    transientField,
    transientIdentifier
} from "@fedeltapointofsale/data-client";
import {BaseConversion} from "../measure/measure.data";
import {OutletReferenceData} from "../../pos/outlet/outlet.data";

export class InventoryManufacturerData extends EntityData<InventoryManufacturerData> {
    @identifier manufacturerId: number;
    @field name: string;
}

export class InventoryMeasureData extends EntityData<InventoryMeasureData> {
    @identifier measureId: number;
    @field name: string;
    @field symbol: string;
    @field base: boolean;
    @component baseConversion: BaseConversion;
}

export class InventoryStockSizeData extends LocalisableEntityData<InventoryStockSizeData> {
    @field measureAmt: number;
    @component @reloadable measure: InventoryMeasureData;
    @transientField measureStr: string;

    @transientIdentifier
    get id(): string {
        if (this.measureAmt != undefined && this.measure != undefined) {
            return this.measureAmt + "-" + this.measure.measureId;
        } else {
            return undefined;
        }
    }

    set id(value: string) {
    }

    get name(): string {
        return this.measureAmt + " * " + this.measure.name;
    }

    set name(value: string) {
    }
}

export class InvInventoryGroupData extends EntityData<InvInventoryGroupData> {
    @field invGroupId: number;
}

export class InventoryTaxData extends EntityData<InventoryTaxData> {
    @identifier id: number;
    @field name: string;
}

export class InventoryVendorData extends LocalisableEntityData<InventoryVendorData> {
    @identifier vendorId: number;
    @field name: string;
    @field code: string;
}

export class SuppliedInventoryData extends EntityData<SuppliedInventoryData> {
    @identifier suppliedInventoryId: number;
    @field negotiatedSupplierPrice: number;
    @field code: string;
    @component vendor: InventoryVendorData;
    @component stockSize: InventoryStockSizeData;
    @transientField preferredSupplier: boolean = false;
}

export class InventoryBarcodeSizeData extends EntityData<InventoryBarcodeSizeData> {
    @identifier id: number;
    @field barcode: string;
    @component stockSize: InventoryStockSizeData;
}

export class RecipeInventoryData extends EntityData<RecipeInventoryData> {
    @identifier inventoryId: number;
    @field name: string;
}

export class OutletStockData extends EntityData<OutletStockData> {
    @identifier outletStockID: number;
    @field minLevel: number;
    @field maxLevel: number;
    @field purchaseOrder: boolean = true;
    @field receiveOrder: boolean = true;
    @field stockTransfer: boolean = true;
    @component outlet: OutletReferenceData;
    @component stockSize: InventoryStockSizeData;
    @component inventory: RecipeInventoryData;
}

export class InventoryRecipeItemData extends EntityData<InventoryRecipeItemData> {
    @field amount: number;
    @component inventory: RecipeInventoryData;
    @component stockSize: InventoryStockSizeData;

}

export class InventoryReferenceData extends LocalisableEntityData<InventoryReferenceData> {
    @identifier inventoryId: number;
    @field name: string;
}

export class InventoryData extends LocalisableEntityData<InventoryData> {
    @identifier inventoryId: number;
    @field name: string;
    @field sku: string;
    @field source: string;
    @field details: string;
    @field discontinued: boolean;
    @component manufacturer: InventoryManufacturerData;
    @component standardStockSize: InventoryStockSizeData;
    @component inventoryGroup: InvInventoryGroupData;
    @collection(InventoryTaxData) taxes: InventoryTaxData[];
    @collection(SuppliedInventoryData) suppliedInventories: SuppliedInventoryData[];
    @component preferredSupplier: InventoryVendorData;
    @component customObjectContext: CustomObjectContextData;
    @collection(OutletStockData) outletStocks: OutletStockData[];
    @collection(InventoryBarcodeSizeData) barcodes: InventoryBarcodeSizeData[];
    @collection(InventoryRecipeItemData) recipeItems: InventoryRecipeItemData[];
    @field recipeQuantity: number;
    @component recipeStockSize: InventoryStockSizeData;
}
